


window.SLEEPWHALE_CONFIG = {
    "buckets": ["preSleep", "stayingAsleep", "moodEnergy"],
    "tallies": ["racingMind", "hormonal", "routine", "triedCount"],
    "display": {
        "barOrder": ["preSleep", "stayingAsleep", "moodEnergy"],
        "barLabels": {
            "preSleep": "Falling asleep",
            "stayingAsleep": "Staying asleep",
            "moodEnergy": "Next-day energy"
        },
        "scaleMax": 4,
        "scaleMeaning": "severity — how much this is affecting your life, combining how often and how badly",
        "severityLabels": {
            "4": "Severe",
            "3": "Moderate",
            "2": "Mild",
            "1": "Minimal",
            "0": "None"
        },
        "coreIssueBump": 1,
        "minCoreLevel": 1,
        "coreIssueMarker": {
            "label": "Core issue",
            "icon": "exclamation"
        }
    },
    "thresholds": {
        "racingMind": 1,
        "hormonal": 2,
        "routine": 1,
        "triedCount": 3
    },
    "flagsFromTallies": {
        "triedItAll": { "tally": "triedCount", "atLeast": 3 }
    },
    "minEvidence": 1.5,
    "tieBreak": ["stayingAsleep", "moodEnergy", "preSleep"],
    "routing": {
        "womenValue": "women",
        "byPrimaryBucket": {
            "preSleep": 5,
            "moodEnergy": 4
        },
        "guards": {
            "5": { "requiresEvidence": "directPreSleep", "fallbackToChain": true },
            "4": { "requiresEvidence": "fatigue", "fallbackToChain": true }
        },
        "conflictWhen": [
            { "flag": "nocturia" },
            { "tally": "routine", "atLeast": 1 }
        ],
        "chain": [
            { "flag": "nocturia", "profile": 3 },
            { "tally": "racingMind", "atLeast": 1, "profile": 1 },
            { "otherwise": true, "profile": 6 }
        ],
        "lowConfidenceProfile": 6
    }
};

const PRIMARY_PRODUCT_URL = "https://sleepwhale.com/pages/quiz-sales"


window.QUIZ_CONTENT = {
 profiles: {
        1: {
            title: "The Racing Mind",
            icon: "https://cdn.shopify.com/s/files/1/0554/8087/7221/files/quiz-profileAll.svg",
            description: "You usually fall asleep okay, but you wake up in the middle of the night. When you’re up for any reason, your mind switches on, and falling back to sleep is a challenge.",
            recommendationHtml: "Solutions that <strong>calm an active mind and hold sleep through the night</strong> are most helpful for your type.",
            variants: [
                {
                    conditions: { flag: "directPreSleep" },
                    description: "Your mind struggles to shut down, making it hard to fall asleep initially. When you wake up in the middle of the night, your brain switches right back on, making it a challenge to drift back off."
                }
            ],
            commonality: {
                "Women 60+": [1, 3],
                "Men 60+": [2, 5],
                "All 60+": [1, 3],
                "All women": [1, 3],
                "All men": [1, 3],
                "Default": [1, 3]
            },
            bestIngredients: ["cbn_isolate", "nano_hemp", "l_theanine"],
            supportingIngredients: ["mag_citrate", "chamomile", "lions_mane"],
            primaryProductUrl: PRIMARY_PRODUCT_URL,
            productOfferPage: {
               gallery: [
                    {
                        url: "https://cdn.shopify.com/s/files/1/0554/8087/7221/files/prod-racingmind.png"
                    },
                    {
                        url: "https://cdn.shopify.com/s/files/1/0554/8087/7221/files/carousel_drops_2_no_extra.jpg"
                    },
                    {
                        url: 'https://cdn.shopify.com/s/files/1/0554/8087/7221/files/carousel_drops_1.jpg'
                    },
                    {
                        url: 'https://cdn.shopify.com/s/files/1/0554/8087/7221/files/carousel_drops_3_v2.jpg'
                    },
                    {
                        url: "https://cdn.shopify.com/s/files/1/0554/8087/7221/files/sleepDrops_prod_5_99e31832-c91d-498a-bbd0-3fb62f5dde9b.webp"
                    }
                ],
                eyebrow: 'FOR STAYING ASLEEP AND CALMER MIND',
                vp: [{text: "<a href='https://pubmed.ncbi.nlm.nih.gov/37796540/'target='_blank' rel='noopener noreferrer'>Shown in studies</a> to reduce nighttime wake ups", iconUrl: "https://cdn.shopify.com/s/files/1/0554/8087/7221/files/Feature_icon_3.svg?v=1787351293"}]
            }
        },
        3: {
            title: "Midnight Bathroom Breaks + Wakeups", 
            icon: "https://cdn.shopify.com/s/files/1/0554/8087/7221/files/quiz-profileAll.svg",
            description: "Your nights get broken mainly by trips to the bathroom, and once you’re up, falling asleep again is typically not easy for you.",
            recommendationHtml: "Solutions that <strong>support sleep through the night without adding to bathroom pressure</strong> are most helpful for your type.",
            commonality: {
                "Women 60+": null, 
                "Men 60+": [1, 4],
                "All 60+": [1, 6],
                "All women": null, 
                "All men": [1, 5],
                "Default": [1, 5]
            },
            bestIngredients: ["cbn_isolate", "nano_hemp", "mag_citrate"], 
            supportingIngredients: ["l_theanine", "chamomile", "lions_mane"], 
            primaryProductUrl: PRIMARY_PRODUCT_URL,
               productOfferPage: {
                         gallery: [
                    {
                        url: "https://cdn.shopify.com/s/files/1/0554/8087/7221/files/prod-midnightbath.png"
                    },
                    {
                        url: "https://cdn.shopify.com/s/files/1/0554/8087/7221/files/carousel_drops_2_no_extra.jpg"
                    },
                    {
                        url: 'https://cdn.shopify.com/s/files/1/0554/8087/7221/files/carousel_drops_1.jpg'
                    },
                    {
                        url: 'https://cdn.shopify.com/s/files/1/0554/8087/7221/files/carousel_drops_3_v2.jpg'
                    },
                    {
                        url: "https://cdn.shopify.com/s/files/1/0554/8087/7221/files/sleepDrops_prod_5_99e31832-c91d-498a-bbd0-3fb62f5dde9b.webp"
                    }
                ],
                eyebrow: 'FOR FEWER NIGHTTIME WAKEUPS',
                vp: [{text: "<a href='https://pubmed.ncbi.nlm.nih.gov/37796540/' target='_blank' rel='noopener noreferrer'>Shown in studies</a> to reduce nighttime wake ups", iconUrl: "https://cdn.shopify.com/s/files/1/0554/8087/7221/files/Feature_icon_3.svg?v=1787351293"},{text: 'Lowers physical tension and stress', iconUrl: "https://cdn.shopify.com/s/files/1/0554/8087/7221/files/Feature_icon_7.svg?v=1787351293"},{text: 'Fall back asleep again faster', iconUrl: "https://cdn.shopify.com/s/files/1/0554/8087/7221/files/Feature_icon_12.svg?v=1787351294"}]
            }
        },
        4: {
            title: "Daytime Slump",
            icon: "https://cdn.shopify.com/s/files/1/0554/8087/7221/files/quiz-profileAll.svg",
            description: "For you, falling asleep and staying asleep is not a core issue, but you’re still low on energy and the days feel foggy. Sleep quality is the likely culprit.",
            recommendationHtml: "Solutions that <strong>deepen sleep quality, so your nights actually restore you</strong> are most helpful for your type.",
            commonality: {
                "Women 60+": [1, 5],
                "Men 60+": [1, 5],
                "All 60+": [1, 5],
                "All women": [1, 5],
                "All men": [1, 5],
                "Default": [1, 5]
            },
            bestIngredients: ["cbn_isolate", "nano_hemp","l_theanine", ], 
            supportingIngredients: ["mag_citrate", "chamomile", "lions_mane"], 
            primaryProductUrl: PRIMARY_PRODUCT_URL,
            productOfferPage: {
                gallery: [
                    {
                        url: "https://cdn.shopify.com/s/files/1/0554/8087/7221/files/prod-daytimeslump.png"
                    },
                    {
                        url: "https://cdn.shopify.com/s/files/1/0554/8087/7221/files/carousel_drops_2_no_extra.jpg"
                    },
                    {
                        url: 'https://cdn.shopify.com/s/files/1/0554/8087/7221/files/carousel_drops_1.jpg'
                    },
                    {
                        url: 'https://cdn.shopify.com/s/files/1/0554/8087/7221/files/carousel_drops_3_v2.jpg'
                    },
                    {
                        url: "https://cdn.shopify.com/s/files/1/0554/8087/7221/files/sleepDrops_prod_5_99e31832-c91d-498a-bbd0-3fb62f5dde9b.webp"
                    }
                ],
                eyebrow: 'DEEPER SLEEP FOR DAYTIME ENERGY',
                vp: [{text: "<a href='https://pmc.ncbi.nlm.nih.gov/articles/PMC11774964/' target='_blank' rel='noopener noreferrer'>Shown in studies</a> to improve daytime alertness", iconUrl: "https://cdn.shopify.com/s/files/1/0554/8087/7221/files/Feature_icon_5.svg?v=1787351294"},{text: 'Improved sleep quality', iconUrl: "https://cdn.shopify.com/s/files/1/0554/8087/7221/files/Feature_icon_4.svg?v=1787351293"},{text: 'Zero morning grogginess', iconUrl: "https://cdn.shopify.com/s/files/1/0554/8087/7221/files/Feature_icon_5.svg?v=1787351294"}]
            }
        },
        5: {
            title: "Can’t Fall Asleep",
            icon: "https://cdn.shopify.com/s/files/1/0554/8087/7221/files/quiz-profileAll.svg",
            description: "You lie down tired to sleep, but your mind and nervous system doesn’t want to cooperate, and the sleepless minutes start to add up struggling to fall asleep.",
            recommendationHtml: "Solutions that <strong>quiet the nervous system before bed, without leaving you groggy</strong> are most helpful for your type.",
            commonality: {
                "Women 60+": [1, 5],
                "Men 60+": [1, 6],
                "All 60+": [1, 6],
                "All women": [1, 5],
                "All men": [1, 6],
                "Default": [1, 5]
            },
            bestIngredients: ["cbn_isolate", "nano_hemp", "chamomile"], 
            supportingIngredients: ["mag_citrate", "l_theanine", "lions_mane"], 
            primaryProductUrl: PRIMARY_PRODUCT_URL,
               productOfferPage: {
                         gallery: [
                    {
                        url: "https://cdn.shopify.com/s/files/1/0554/8087/7221/files/prod-cantfallasleep.png"
                    },
                    {
                        url: "https://cdn.shopify.com/s/files/1/0554/8087/7221/files/carousel_drops_2_no_extra.jpg"
                    },
                    {
                        url: 'https://cdn.shopify.com/s/files/1/0554/8087/7221/files/carousel_drops_1.jpg'
                    },
                    {
                        url: 'https://cdn.shopify.com/s/files/1/0554/8087/7221/files/carousel_drops_3_v2.jpg'
                    },
                    {
                        url: "https://cdn.shopify.com/s/files/1/0554/8087/7221/files/sleepDrops_prod_5_99e31832-c91d-498a-bbd0-3fb62f5dde9b.webp"
                    }
                ],
                eyebrow: 'FOR FALLING ASLEEP',
                vp: [{text: "<a href='https://pmc.ncbi.nlm.nih.gov/articles/PMC13357646/' target='_blank' rel='noopener noreferrer'>Shown in studies</a> to help fall asleep faster", iconUrl: "https://cdn.shopify.com/s/files/1/0554/8087/7221/files/Feature_icon_12.svg?v=1787351294"},{text: 'Rapid Absorption - Feel it in minutes', iconUrl: "https://cdn.shopify.com/s/files/1/0554/8087/7221/files/Feature_icon_1.svg?v=1787351293"}]
            }
        },
        6: {
            title: "Midnight Riser",
            icon: "https://cdn.shopify.com/s/files/1/0554/8087/7221/files/quiz-profileAll.svg",
            description: "You wake in the middle of the night, but the reason isn’t always clear and may not have an obvious pattern. The good news: this is a common experience.",
            recommendationHtml: "Solutions that <strong>steady your system through the whole night</strong> are most helpful for your type.",
            commonality: { "Default": [1, 4] },
            bestIngredients: ["cbn_isolate", "nano_hemp", "mag_citrate"],
            supportingIngredients: ["chamomile", "lions_mane", "l_theanine"],
            primaryProductUrl: PRIMARY_PRODUCT_URL,
            productOfferPage: {
                         gallery: [
                    {
                        url: "https://cdn.shopify.com/s/files/1/0554/8087/7221/files/prod-midnightriser.png"
                    },
                    {
                        url: "https://cdn.shopify.com/s/files/1/0554/8087/7221/files/carousel_drops_2_no_extra.jpg"
                    },
                    {
                        url: 'https://cdn.shopify.com/s/files/1/0554/8087/7221/files/carousel_drops_1.jpg'
                    },
                    {
                        url: 'https://cdn.shopify.com/s/files/1/0554/8087/7221/files/carousel_drops_3_v2.jpg'
                    },
                    {
                        url: "https://cdn.shopify.com/s/files/1/0554/8087/7221/files/sleepDrops_prod_5_99e31832-c91d-498a-bbd0-3fb62f5dde9b.webp"
                    }
                ],
                eyebrow: 'FOR STAYING ASLEEP ALL NIGHT',
                vp: [{text: "<a href='https://pubmed.ncbi.nlm.nih.gov/37796540/' target='_blank' rel='noopener noreferrer'>Shown in studies</a> to reduce nighttime wake ups", iconUrl: "https://cdn.shopify.com/s/files/1/0554/8087/7221/files/Feature_icon_3.svg?v=1787351293"},{text: 'Fall back asleep faster', iconUrl: "https://cdn.shopify.com/s/files/1/0554/8087/7221/files/Feature_icon_12.svg?v=1787351294"},{text: 'Sleep through the night until morning', iconUrl: "https://cdn.shopify.com/s/files/1/0554/8087/7221/files/Feature_icon_3.svg?v=1787351293"}]
            }
        
        },
    },
    rootCauses: {
        hormonal: {
            label: "Biological / Hormonal",
            description: "Your answers suggest that age-related hormonal/biological changes are a primary sleep issue driver. While the underlying system behind this is complex, the sleep issues can be managed and improved.",
            bullets: ["Get more sleep", "Get better at sleep", "Make an effort"]
        },
        routine: {
            label: "Habits / Routine",
            description: "Your answers suggest that your nighttime and pre-sleep habits are likely contributing to your core sleep issues. This is an area where tiny steps can make big improvements.",
            bullets: ["Delays melatonin production", "Confuses your body clock"]
        },
        nocturia: {
            label: "Bathroom Wakeups",
            description: "Over 2 out of 3 adults under 60 wake up to use the bathroom at night. We recommend avoiding powders and sleep drinks before bed in your case.",
            bullets: ["Breaks deep sleep", "Makes falling back asleep difficult"]
        },
        nocturiaOver60: {
            label: "Bathroom Wakeups",
            description: "Over 85% of Adults 60+ wake up during the night to use the bathroom. About half wake up multiple times. We recommend avoiding powders and sleep drinks before bed in your case.",
            bullets: ["Breaks deep sleep", "Makes falling back asleep difficult"]
        },
        triedItAll: {
            label: "Tried It All",
            description: "You have tried many solutions and fixes, but haven’t yet landed on one that works. Your experience likely requires a holistic approach to sleep support that minimizes side effects.",

        }

    },
    ingredients: {
        cbn_isolate: {
            name: "CBN Isolate",
            icon: 'https://cdn.shopify.com/s/files/1/0554/8087/7221/files/quiz-cbn.png?v=1785533894',
            match: 98,
            tags: ["Stay asleep", "Sleep deeper"],
            description: "Reduces physical tension, lowers cortisol, and brings the nervous system into a parasympathetic (rest-and-digest) state."
        },
        nano_hemp: {
            icon: 'https://cdn.shopify.com/s/files/1/0554/8087/7221/files/quiz-cbd.png?v=1785533842',
            name: "Nano Hemp",
            match: 94,
            tags: ["Relax the body", "Relax nervous system"],
            description: "Our water-soluble hemp extract absorbs up to 5x faster than traditional oils to help you wind down quickly."
        },
        l_theanine: {
            name: "Suntheanine®", 
            icon: 'https://cdn.shopify.com/s/files/1/0554/8087/7221/files/quiz-theanine.png?v=1785533877',
            match: 94, 
            tags: ["Reduce anxiety", "Balance mind"],
            description: "An amino acid from green tea that boosts alpha brainwaves — promoting calm alertness without grogginess. Balances the formula’s sedative elements for a smooth glide into sleep."
        },
        mag_citrate: {
            name: "Gadomag+", 
            icon: 'https://cdn.shopify.com/s/files/1/0554/8087/7221/files/quiz-magnesium.png?v=1785533865',
            match: 88, 
            tags: ["Relax muscles", "Calm body"],
            description: "Helps muscles fully relax and may reduce nighttime cramping — complements Magtein with a more body-focused magnesium source."
        },
        chamomile: {
            name: "Sibelius™ Chamomile", 
            icon: 'https://cdn.shopify.com/s/files/1/0554/8087/7221/files/quiz-chamomile.png?v=1785533854',
            match: 84, 
            tags: ["Relax the body"],
            description: "Time-tested herbal relaxant that reduces anxiety and tension — traditionally used to ease into sleep."
        },
        lions_mane: {
            name: "M2 Lions Mane", 
            icon: "https://cdn.shopify.com/s/files/1/0554/8087/7221/files/quiz-lionsmane.png?v=1785533827",
            match: 79, 
            tags: ["Nervous system support"],
            description: "Supports neurogenesis and brain health — helps create long-term resilience against stress and mental fatigue."
        }
    },
    research: [
        {
            label: "(1) The Importance of High Quality Sleep in Older Adults",
            url: "https://www.aarp.org/pri/topics/health/prevention-wellness/healthy-living-sleep/"
        },
        {
            label: "(2) Sleep deprivation and motivation / anxiety",
            url: "https://academic.oup.com/sleep/article-abstract/44/Supplement_2/A304/6260657?redirectedFrom=fulltext"
        },
        {
            label: "(3) Sleep deprivation and anger/irritability",
            url: "https://academic.oup.com/sleep/article-abstract/44/Supplement_2/A304/6260657?redirectedFrom=fulltext"
        },
        {
            label: "(6) Sleep disorders and depression in midlife women",
            url: "https://pmc.ncbi.nlm.nih.gov/articles/PMC5604858/"
        },
        {
            label: "(7) Staying asleep and deep sleep in men",
            url: "https://jamanetwork.com/journals/jama/fullarticle/192981"
        },
        {
            label: "(8) Post-menopause women and health effects of poor sleep",
            url: "https://pubmed.ncbi.nlm.nih.gov/41190624/"
        }
    ]
};

